export const 
CAPTCHA_PENDING = 'CAPTCHA_PENDING',
CAPTCHA_SUCCESS = 'CAPTCHA_SUCCESS',
CAPTCHA_FAILURE = 'CAPTCHA_FAILURE',
CAPTCHA_RESET = 'CAPTCHA_RESET',
CAPTCHA_VALIDATION_PENDING = 'CAPTCHA_VALIDATION_PENDING',
CAPTCHA_VALIDATION_SUCCESS = 'CAPTCHA_VALIDATION_SUCCESS',
CAPTCHA_VALIDATION_FAILURE = 'CAPTCHA_VALIDATION_FAILURE',
CAPTCHA_VALIDATION_RESET = 'CAPTCHA_VALIDATION_RESET',
CAPTCHA_INPUT_FIELD_UPDATE = 'CAPTCHA_INPUT_FIELD_UPDATE',
CAPTCHA_FIELD_RESET = 'CAPTCHA_FIELD_RESET',
CAPTCHA_SET_VALIDATED = 'CAPTCHA_SET_VALIDATED';

